const {traversePropertiesArray, traversePropertiesString} = require('./shared');
const {milMBA} = require("./appConverters/milMBA");
const {spouseMBA} = require("./appConverters/spouseMBA");

module.exports.ApplicationData = () => {
  let formData;
  let formId;

  function neededApps() {
    let needApps = [];

    const isMarried = traversePropertiesString(formData, ['basic', 'relationshipStatus']) === "M";
    // console.log("Married", isMarried);
    const primaryNeed = traversePropertiesString(formData, ['basic', 'memberStatus']) !== "ZZ";
    // console.log("primNeed", primaryNeed);
    const spouseNeed = isMarried && traversePropertiesString(formData, ['basic', 'spcstatus']) !== "ZZ";
    // console.log("spouseNeed", spouseNeed);
    const isMiltoMil = isMarried && traversePropertiesString(formData, ['basic', 'milmembers']) === "2";
    // console.log("mil to mil", isMiltoMil);

    //MBA determination
    const isMBA = traversePropertiesArray(formData, ['basic', 'selectedApps']).indexOf("MBA") !== -1;
    if (isMBA) {
      if (!isMarried) {
        needApps.push({person: "primary", type: 'milMBA', originalId: formId});
      } else {
        if (primaryNeed) {
          needApps.push({person: "primary", type: 'milMBA', originalId: formId});
        }
        if (spouseNeed) {
          if (isMiltoMil) {
            needApps.push({person: "spouse", type: 'milMBA', originalId: formId});
          } else {
            needApps.push({person: "spouse", type: 'spouseMBA', originalId: formId});
          }

        }
      }
    }

    return needApps;
  };

  function getArrayAppData(data) {
    // console.log(data);
    if (data.hasOwnProperty('formData') && data.hasOwnProperty("id")) {
      formData = data.formData;
      formId = data.id;
      //Get needed Apps
      const needApps = neededApps();
      let clearedToProcess = true;
      let errorString = null;
      //Convert each App, return with error if Data not available to process
      let processedData = [];
      needApps.some((data) => {
        const res = convertApp(data);
        if (res.error) {
          errorString = "Error in " + res.type + " for " + res.person + ": " + res.error;
          return true;
        } else {
          processedData.push(res.data);
        }
      });
      if (errorString) {
        return {status: "Error", data: errorString};
      } else {
        return {status: "Success", data: processedData};
      }
    } else {
      return [];
    }
  }

  function convertApp(req) {
    let res = {};
    switch (req.type) {
      case "milMBA":
        res = milMBA({req, formData});
        // console.log(res);
        break;
      case "spouseMBA":
        res = spouseMBA({req, formData});
        break;
      default:
        res = {
          status: false,
          person: req.person,
          type: req.type,
          error: "Cannot process. Type not Implemented",
          data: {}
        };
        break;
    }
    return res;
  }

  return {
    convert: (formData) => getArrayAppData(formData)
  };
};

const singleDataNoDeps = {
  "formData": {
    "primary": {
      "fname": "Test",
      "middleInitial": "P",
      "lname": "Person",
      "gender": "M",
      "bdate": "04/21/1989",
      "ssn": "999-99-9999",
      "tobacco": "N",
      "currentAddress": "234 Testing Lane",
      "currentZip": "80902",
      "currentCity": "Colorado Springs",
      "currentState": "CO",
      "phone": "213-123-1234",
      "workPhone": "213-123-1234",
      "email": "test@testing.com",
      "dutyStatus": "2",
      "separationDate": "10/20/2023",
      "branch": "2",
      "rank": "PFC",
      "serviceUnit": "23rd test"
    },
    "basic": {"selectedApps": ["MBA"], "relationshipStatus": "S", "memberStatus": "N"},
    "payment": {"method": "CHECK", "frequency": "Q"},
    "coverages": {"mbaCoverage": "250000"},
    "health": {"heightFt": "5", "heightIn": "10", "weight": "172"},
    "beneficiary": {
      "beneficiary": [{
        "fullName": "My Test Father",
        "ssn": "888-88-8888",
        "bdate": "10/20/1965",
        "relationship": "Father",
        "phone": "213-123-12344",
        "physicianAddress": "123 Testing Way",
        "physicianZip": "75219",
        "physicianCity": "Dallas",
        "physicianState": "TX"
      }]
    },
    "dependents": []
  },
  "id": "a63daa14-4512-4590-b681-a385585d7e07"
}
const marriedMilToMil2Kids = {
  "action": "edit", "type": "save", "formData": {
    "primary": {
      "fname": "Test",
      "middleInitial": "P",
      "lname": "Person",
      "gender": "M",
      "bdate": "04/21/1989",
      "ssn": "999-99-9999",
      "tobacco": "N",
      "currentAddress": "234 Testing Lane",
      "currentZip": "80902",
      "currentCity": "Colorado Springs",
      "currentState": "CO",
      "phone": "213-123-1234",
      "workPhone": "213-123-1234",
      "email": "test@testing.com",
      "dutyStatus": "2",
      "separationDate": "10/20/2023",
      "branch": "2",
      "rank": "PFC",
      "serviceUnit": "23rd test",
      "tobacco": "N"
    },
    "basic": {
      "selectedApps": ["MBA"],
      "relationshipStatus": "M",
      "memberStatus": "N",
      "spcstatus": "N",
      "milmembers": "1"
    },
    "payment": {"method": "CHECK", "frequency": "Q"},
    "coverages": {"mbaCoverage": "250000"},
    "health": {"heightFt": "5", "heightIn": "10", "weight": "172"},
    "beneficiary": {
      "beneficiary": [{
        "fullName": "My Test Father",
        "ssn": "888-88-8888",
        "bdate": "10/20/1965",
        "relationship": "Father",
        "phone": "213-123-12344",
        "physicianAddress": "123 Testing Way",
        "physicianZip": "75219",
        "physicianCity": "Dallas",
        "physicianState": "TX"
      }], "usePrimary": 1, "useSpouse": 1
    },
    "dependents": [{
      "fname": "John",
      "middleInitial": "D",
      "lname": "Doe",
      "gender": "M",
      "bdate": "09/30/2003",
      "ssn": "123-45-6789"
    }, {
      "fname": "Sally",
      "middleInitial": "G",
      "lname": "Doe",
      "gender": "F",
      "bdate": "10/31/2012",
      "ssn": "234-56-7890"
    }],
    "spouse": {
      "fname": "First",
      "middleInitial": "M",
      "lname": "Last",
      "gender": "F",
      "bdate": "03/23/1995",
      "ssn": "123-45-6789",
      "tobacco": "N",
      "currentUseNew": "",
      "permanentUseNew": "",
      "phone": "234-567-8901",
      "workPhone": "234-567-8901",
      "email": "email@email.com",
      "dutyStatus": "2",
      "separationDate": "10/05/2023",
      "branch": "2",
      "rank": "PV2",
      "serviceUnit": "57",
      "tobacco": "N"
    },
    "spouseHealth": {"heightFt": "5", "heightIn": "4", "weight": "135"}
  }, "display": "Test Person Family", "id": "a63daa14-4512-4590-b681-b385585d7e07"
}
const validator = {}

const goodData = {
  type: "spouseMBA",
  data: {
    basic: {
      memberStatus: 'N', // *
      firstName: "Test", // *
      middleInitital: "T",
      lastName: "Dummy", // *
      gender: "F", // *
      relationshipStatus: "M", // *
      dateOfBirth: "04/21/1985", // *
      tobaccoUse: false, // *
      currentStreet: "Street Address 1", // *
      currentZip: "28344", // *
      permanentStreet: "Street Address 1", // * could add checkbox Same as current mailing address
      permanentZip: "28344", // *
      phone: "702-123-1234", // *
      workPhone: "702-123-1234",
      email: "email@email.com" // *
    },
    sponsor: {
      firstName: "TEST", // *
      middleInitital: "T",
      lastName: "DUMMY", // *
      ssn: "234-23-1234", // *
      serviceUnit: "service unit",
      unitPhone: "234-232-1234",
      branch: "2", // *
      rank: "PFC", // *
      dutyStatus: "I" // *
    },
    coverage: {
      readMaterials: true, // *
      coverage: "100000", // *
      replacingExistingCoverage: false // *
    },
    dependents: [ // if applicable
      {
        firstName: "First", // *
        mi: "T",
        lastName: "Kid", // *
        dob: "11/17/2010", // *
        gender: "M" // *
      }, {
        firstName: "Second",
        mi: "A",
        lastName: "Kid",
        dob: "12/05/2012",
        gender: "F"
      }
    ],
    health: {
      feet: "5", // *
      inches: "10", // *
      weight: "135", // *
      noPhysician: false,
      physicianName: "Test Physician", // * If above is true
      physicianPhone: "234-123-4567", // *
      physicianStreet: "Street Address", // *
      physicianZip: "75218", // *
      lastVisitDate: "11/17/2018", // *
      lastVisitReason: "Flu like symptoms", // *
      otherMedication: [],
      everDeclined: [],
      disabilityPay: [],
      dwiConviction: "", // "10/17/2016", // *
      hiv: [],
      anyDisease: [],
      hospitalized: [],
      advice: []
    },
    fraud: {}, // * Handled
    beneficiaries: {
      primary: [ // * first
        {
          name: "Test Ben", // *
          ssn: "123-34-5678", // *
          dateOfBirth: "11/23/1994", // *
          relationship: "UNCLE", // *
          phone: "234-123-1234", // *
          street: "123 D AVE", // *
          zip: "75219", // *
          sharePercent: "34" // *
        },
        {
          name: "Test Ben 2",
          ssn: "123-34-5678",
          dateOfBirth: "11/23/1994",
          relationship: "UNCLE",
          phone: "234-123-1234",
          street: "123 D AVE",
          zip: "75219",
          sharePercent: "66"
        }
      ],
      contingent: []
    },
    declarations: {ssn: "123-54-8490"}, // *
    agent: {name: "Travis Johnson", phone: "253-202-2064", date: "02/04/2019", code: "03510", agencyCode: "9500"}, // *
    payment: {
      method: 'eft', // *
      eft: {
        bankName: "USAA",
        bankStreet: "10750 McDermott Freeway",
        bankZip: "78288",
        routingNumber: "314074269",
        accountNumber: "1234"
      },
      cc: {
        holder: "Test Dummy",
        billingStreet: "123 Test Lane",
        billingCountry: "US",
        billingZip: "75219",
        cardType: "mc",
        cardNum: "5444444444444444",
        expDate: "04/2020",
        cvv: "123",
        freq: "Q",
        recurring: true
      },
      check: {
        freq: "S"
      },
      maa: {
        firstMonth: "04/01/2019"
      },
      immediate: false
    }
  }
};
// console.log(module.exports.ApplicationData().convert(marriedMilToMil2Kids));
// console.log(module.exports.ApplicationData().convert(singleDataNoDeps));




// WEBPACK FOOTER //
// ./src/containers/Applications/shared/applicationConverter.js